<template>
	<div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 mb-4">
		<div class="card hm400">
			<div class="card-header ">
				<h5 class="card-title">Active Domains</h5>
				<!-- <p class="card-category">List of active domains in your account</p> -->
			</div>
			<div class="card-body pb-0">
				<perfect-scrollbar class="scroll-area">
					<ul class="list-group list-group-flush">
						<li class="list-group-item d-flex justify-content-between align-items-center" v-for="(account, index) in accounts" v-if="account.status === 'active'" :key="index">
							<p class="mb-0">
								<router-link tag="a" :class="{ 'disabled' : account.status === 'pending' }" :to="{ name: 'viewDetails', params: { index: encryptIndex( index.toString() ) } }">
									<strong>{{ account.domain }}</strong><br>
								</router-link>
								<span class="text-secondary">{{ account.planName }}</span>
							</p>
							<span class="badge badge-primary badge-pill">Active</span>
						</li>
						<p class="text-center text-secondary" v-if="accounts.length === 0">No accounts are active.</p>
					</ul>
				</perfect-scrollbar>
			</div>
			<div class="card-footer pt-0">
				<hr class="mt-0">
				<div class="stats">
					<router-link tag="a" :to="{ name: 'siteDetails' }" class="text-secondary nounderline">
						<i class="fa fa-server"></i> More Details
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import encryptIndex from '../../../mixins/encryptIndex'
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';

export default {
	name: "ActiveDomainsList",
	mixins:[encryptIndex],
	props: {
		accounts: Array
	},
	components: {
		PerfectScrollbar,
	},
	computed: {
		aesSecret() {
			return this.$store.getters["crypto/aesSecret"];
		}
	},
};
</script>
